// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__l-nV7","modal":"style_modal__+CHxA"};